module.exports = (__parcel__import__("2zhcp")).then(() => parcelRequire('4MKVl'));